export default __webpack_public_path__ + "static/media/vietnamsky-tet.469976a3.jpg";